<template>
  <section class="flex flex-col items-center mb-20">
      <h3 class="font-semibold text-3xl mb-4">Explore the world with My Dream place</h3>
      <p class="text-light-blue font-normal text-base leading-6 tracking-wide">Discover new places and experiences</p>
  </section>
</template>

<script>
export default {

}
</script>